function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_9_197053)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.102002 2.22305C-0.0332561 2.73194 -0.0323732 3.26745 0.104562 3.7759C0.241498 4.28434 0.509675 4.74786 0.882213 5.11999C1.25475 5.49212 1.71856 5.7598 2.22715 5.89618C2.73575 6.03256 3.27126 6.03286 3.78 5.89705L10.121 12.149C9.98922 12.5967 9.96359 13.069 10.0461 13.5283C10.1287 13.9876 10.3172 14.4214 10.5966 14.7952C10.876 15.1689 11.2387 15.4724 11.6559 15.6816C12.0731 15.8907 12.5333 15.9998 13 16C13.4299 15.9995 13.8547 15.9064 14.2456 15.7273C14.6364 15.5482 14.9842 15.2872 15.2654 14.9619C15.5466 14.6367 15.7545 14.2548 15.8752 13.8421C15.9959 13.4295 16.0265 12.9957 15.9649 12.5702C15.9033 12.1447 15.7509 11.7374 15.5182 11.3759C15.2854 11.0144 14.9777 10.7072 14.6158 10.475C14.2539 10.2429 13.8464 10.0912 13.4208 10.0303C12.9952 9.9694 12.5615 10.0007 12.149 10.122L5.897 3.78105C6.03347 3.27211 6.03367 2.73622 5.89759 2.22718C5.7615 1.71813 5.49391 1.25384 5.12167 0.880897C4.74944 0.507953 4.28566 0.23948 3.77687 0.102423C3.26809 -0.0346336 2.7322 -0.0354522 2.223 0.10005L4.364 2.24205L4 4.00005L2.243 4.36405L0.102002 2.22305ZM13.472 11.242L14 11.268L14.287 11.713L14.732 12L14.758 12.529L15 13L14.758 13.471L14.732 14L14.287 14.287L14 14.732L13.471 14.758L13 15L12.529 14.758L12 14.732L11.713 14.287L11.268 14L11.242 13.471L11 13L11.242 12.529L11.268 12L11.713 11.713L12 11.268L12.529 11.242L13 11L13.471 11.242H13.472Z",
  fill: "currentColor"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_9_197053"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

var SvgWrench = function SvgWrench(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWrench, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wrench.f11b79da.svg";
export { ForwardRef as ReactComponent };